import { createBasicSelector } from 'util/redux'

export const selectLegacyIsInboxBootstrapped = createBasicSelector(
  state => state.app.bootstrappedInbox
)
